module.exports = __webpack_public_path__ + "resources/img/img_zenius_logmanager_1.b056c53a0533da3de6de5041c20b0c9d.png";